import { Component, computed, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ObraSocial } from 'src/app/models/ObraSocial';
import { UsuarioService } from 'src/app/services/usuario.service';
import { AuthService } from 'src/app/services/auth.service';
import { LoadingService } from 'src/app/services/loading.service';
import { normalizeText } from 'src/app/shared/text.util';

@Component({
    selector: 'app-my-account-obra-social-list',
    templateUrl: './my-account-obra-social-list.component.html',
    styleUrls: ['./my-account-obra-social-list.component.css'],
    standalone: false
})
export class MyAccountObraSocialListComponent implements OnInit, OnDestroy {
  private _authService = inject(AuthService);
  private _usuarioService = inject(UsuarioService);
  private _loadingService = inject(LoadingService);
  private _router = inject(Router);
  private _location = inject(Location);

  
  // ------- estado -------
  error = signal<string>('');
  loading = computed(() => this._loadingService.isLoading());

  // búsqueda
  private _debounceHandle: any = null;
  search = signal<string>('');        // lo que se escribe (ya debounceado)
  searchDraft = signal<string>('');   // lo que escribe el usuario en el input (instantáneo)

  // lista filtrada (sin async pipe)
  obrasFiltradas = computed<ObraSocial[]>(() => {
    const term = normalizeText(this.search());

    const all = this._usuarioService.obrasSociales ?? [];
    const activos = all.filter(x => x?.b_activo === true);

    if (!term) return activos;

    return activos.filter(x =>
      normalizeText(x.x_descripcion).includes(term)
    );
  });

  async ngOnInit(): Promise<void> {
    document.documentElement.scrollTop = 0;

    await this._loadingService.run(async () => {
      try {
        await this._authService.ensureSession();
      } catch (e: any) {
        console.error(e);
        this.error.set(e?.message || 'No se pudo cargar tu cuenta.');
        this._router.navigate(['/sign-in']);
      }
    });

    // opcional: precargar el texto del buscador (lo dejamos vacío)
    this.searchDraft.set('');
    this.search.set('');
  }

  ngOnDestroy(): void {
    if (this._debounceHandle) clearTimeout(this._debounceHandle);
  }

  onSearchInput(value: string) {
    // esto se actualiza instantáneo
    this.searchDraft.set(value);

    // debounce 400ms como antes
    if (this._debounceHandle) clearTimeout(this._debounceHandle);
    this._debounceHandle = setTimeout(() => {
      this.search.set(this.searchDraft());
    }, 400);
  }

  isActiveObraSocial(idObraSocial: number): boolean {
    return (this._usuarioService.cliente()?.id_obra_social ?? 0) === idObraSocial;
  }

  selectObraSocial(obraSocial: ObraSocial) {
    const cli = { ...(this._usuarioService.cliente() ?? {}) } as any;
    cli.id_obra_social = obraSocial.id;

    this._usuarioService.cliente.set(cli);
    this._router.navigate(['/my-account-obra-social']);
  }

  back(){
    this._location.back();
  }
}
